/** The thumb's shortest length, so a long list still has something to grab. */
export const MENU_SCROLL_THUMB_MIN_PX = 24

/**
 * The thumb's inset from its lane's edges, on all four sides (the
 * menu-scroll-thumb CSS keeps the same).
 */
export const MENU_SCROLL_THUMB_INSET_PX = 1

/**
 * Where a menu's scroll thumb sits for a list scrolled `scrollTop` of
 * `scrollHeight`, showing `clientHeight`, along a track `trackLength` long
 * (the lane, less the thumb's inset at each end): its length and its offset
 * from the track's top, or `null` when the list fits and there is nothing to
 * scroll.
 */
export function menuScrollThumb(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
  trackLength = clientHeight
): { length: number; offset: number } | null {
  const scrollable = scrollHeight - clientHeight
  if (scrollable < 1 || trackLength <= 0) return null
  const length = Math.min(
    trackLength,
    Math.max(MENU_SCROLL_THUMB_MIN_PX, (trackLength * clientHeight) / scrollHeight)
  )
  const progress = Math.min(1, Math.max(0, scrollTop / scrollable))
  return { length, offset: progress * (trackLength - length) }
}

/** How far the list scrolls for every pixel the thumb is dragged. */
export function menuScrollPerThumbPixel(
  scrollHeight: number,
  clientHeight: number,
  thumbLength: number,
  trackLength = clientHeight
): number {
  const travel = trackLength - thumbLength
  return travel > 0 ? (scrollHeight - clientHeight) / travel : 0
}
